// extracted by mini-css-extract-plugin
export var img = "component-module--img--3vjTI";
export var placeholder = "component-module--placeholder--2fQuS";
export var loading = "component-module--loading--1ZQOP";
export var wFull = "component-module--wFull--21Avd";
export var hFull = "component-module--hFull--2bhb4";
export var objectContain = "component-module--objectContain--2RRJQ";